import React, { useEffect, useMemo, useState } from 'react';

import config from "../config/config";
import WheelchairIcon from "../svg/wheelchair";
import ILetterIcon from '../svg/i-letter';
import EssentialCompanionIcon from '../svg/essential-companion';
import LevelAccessIcon from '../svg/level-access';
import CaptionedIcon from '../svg/captioned';
import AudioDescribedIcon from '../svg/audio-described';
import StarIcon from '../svg/star';
import BslIcon from '../svg/bsl';
import { useMediaQuery } from '../hook/useMediaQuery';
import CrossIcon from '../svg/cross';
import PadlockIcon from '../svg/padlock';

const accessibility_key_message =
  config.OPTION_FIELDS.accessibility_key_message?.innerHTML;

const statusMap = [
    {
        key: 'I',
        text: "Seat information",
        icon: <ILetterIcon/>
    },
    {
        key: 'Wheelchair Lock',
        text: "Wheelchair access*",
        icon: <WheelchairIcon/>
    },
    {
        key: 'Essential Companion Lock',
        text: "Essential companion*",
        icon: <EssentialCompanionIcon/>
    },
    {
        key: 'Level Access',
        text: "Level access",
        icon: <LevelAccessIcon/>
    },
    {
        key: 'Captions',
        text: "Caption box",
        icon: <CaptionedIcon/>
    },
    {
        key: 'PWYC',
        text: "PWYC",
        icon: <StarIcon/>,
        match: value => typeof value === "string" && value.startsWith("PWYC"),
    },
    {
        key: 'BSL',
        text: "BSL",
        icon: <BslIcon/>
    },
    {
        key: 'Audio Described',
        text: "Audio described",
        icon: <AudioDescribedIcon/>
    },
];
  

export default function AccessibilityKey({statusData}) {
    const [isOpen, setIsOpen] = useState(false);
    const isMobile = useMediaQuery(`(max-width: 768px)`);
    
    const statusArray = useMemo(() => {
        let statusSet = new Set();

        Object.keys(statusData.status || {}).forEach((key, index) => {
            const item = statusData.status[key];
            let value = null;

            if(item?.status == 'X') {
                value = item?.lockType?.trim();
            }

            if(item?.status == 'A') {
                value = statusData.info[key]?.status.trim();
            }
            
            if(value) statusSet.add(value);
        })

        return Array.from(statusSet)        
    }, [statusData])
// console.log("statusArray", statusArray)
    const accessibilityContent = (
        <>
            {
                statusArray.length &&
                    <ul className='accessibility-key__list'>
                        {statusMap.map((status, index) => {
                            const exists = status.match 
                                ? statusArray.some(status.match)
                                : statusArray.includes(status.key);

                            return exists
                                ? <li className='accessibility-key__list-item' key={status.key}>
                                    <span className='accessibility-key__icon'>{status.icon}</span> {status.text}</li>
                                : null
                            }
                        )}

                        {                            
                            !statusMap.some(status =>  status.match ? statusArray.some(status.match) : statusArray.includes(status.key)) &&
                                ( <li className='accessibility-key__list-item' key='default'>
                                    <span className='accessibility-key__icon'><PadlockIcon/></span> Other access</li> )
                        }
                    </ul>
            }
            {
                accessibility_key_message &&
                    <div className='accessibility-key__message' dangerouslySetInnerHTML={{__html: accessibility_key_message}}></div>
            }
        </>
    )


    if(!statusData || !statusArray.length) return null;

    return (
        isMobile ? 
            <details onToggle={(e) => setIsOpen(e.target.open)} className='details details--accessibility-key'>
                <summary>Key <CrossIcon /></summary>
                <div className='accessibility-key'>
                    {accessibilityContent}
                </div>
            </details>
            : <div className="accessibility-key">
                <h4 className='accessibility-key__title'>Key</h4>                
                {accessibilityContent}
            </div>
    )
}